<script lang="ts" setup></script>

<template>
  <header
    class="flex items-center justify-between gap-4 border-b border-green-900 bg-black p-4"
  >
    <slot />
  </header>
</template>

<style scoped></style>
